import styled from "styled-components";
import theme from "@src/Tools/MuiTheme";

export const STTabsContentWrapper = styled.div`
  && {
    ${theme.breakpoints.down("xs")} {
      min-width: 280px;
      margin-left: 25px;
      margin-right: 25px;
    }

    ${theme.breakpoints.up("sm")} {
      width: 600px;
      margin-left: 35px;
      margin-right: 35px;
    }
  }
`;

export const STFormContentWrapper = styled.div`
  && {
    ${theme.breakpoints.down("xs")} {
      padding-top: 3rem;
    }

    ${theme.breakpoints.up("sm")} {
      padding-top: 3rem;
    }
  }
`;
